import Dashboard from '../index';
import Type24A from '../Type24A';
import Type29 from '../Type29';
import Type30A from '../Type30A';
import Type31 from '../Type31';
import Type35 from '../Type35';
import Type35A from '../Type35A';
import Type57A from '../Type57A';
import Type61 from '../Type61';
import Type62 from '../Type62';
import Type63 from '../Type63';
import Type64 from '../Type64';
import Type65 from '../Type65';
import Type67 from '../Type67';
import Type68 from '../Type68';
import Type69 from '../Type69';
import Type70 from '../Type70';
import Type70A from '../Type70A';
import Type71A from '../Type71A';
import Type72A from '../Type72A';
import Type72B from '../Type72B';

const routes = [
  {
    path: '/olympic/admin/classes/2/types/type62',
    name: 'Type 1 (RD) - Type 62',
    component: Type62,
    layout: '/lms',
    exact: true,
  },

  {
    path: '/olympic/admin/classes/2/types/type63',
    name: 'Type 2 (RD) - Type 63',
    component: Type63,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type57A',
    name: 'Type 3 (RD) - Type 57A',

    component: Type57A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type64',
    name: 'Type 4 (RD) - Type 64',

    component: Type64,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type61',
    name: 'Type 5 (RD) - Type 61',

    component: Type61,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type67',
    name: 'Type 7 (RD) - Type 67',

    component: Type67,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type29',
    name: 'Type 8 (RD) - Type 29',

    component: Type29,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type30A',
    name: 'Type 9 (RD) - Type 30A',

    component: Type30A,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/2/types/type31',
    name: 'Type 10 (RD) - Type 31',

    component: Type31,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type68',
    name: 'Type 11 (RD) - Type68',

    component: Type68,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type35A',
    name: 'Type 12 (RD) - Type35A',

    component: Type35A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type24A',
    name: 'Type 13 (RD) - Type24A',

    component: Type24A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type69',
    name: 'Type 14 (RD) - Type69',

    component: Type69,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type35',
    name: 'Type 15 (RD) - Type35',

    component: Type35,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type70',
    name: 'Type 16 (RD) - Type70',

    component: Type70,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type65',
    name: 'Type 17 (RD) - Type65',

    component: Type65,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type70A',
    name: 'Type 18 (RD) - Type70A',

    component: Type70A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type71A',
    name: 'Type 19 (RD) - Type71A',

    component: Type71A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type72A',
    name: 'Type 20 (RD) - Type72A',

    component: Type72A,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/2/types/type72B',
    name: 'Type 21 (RD) - Type72B',

    component: Type72B,
    layout: '/lms',

    exact: true,
  },
  
];

export default routes;
